import { Tabs } from "@mantine/core";
import React from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import BatchJobSettingsBanner from "../../../../../components/BatchJobSettingsBanner/BatchJobSettingsBanner";
import { BatchJobTemplateEnum } from "../../batchJobConstants";
import BatchJobLogPage from "../../logg/BatchJobLogPage";
import Bim360SheetExtractorSettingsPage from "./Bim360SheetExtractorSettingsPage";
import { useAppSelector } from "../../../../../hooks";

const Bim360SheetExtractor: React.FC = () => {
  const location = useLocation();

  const project = useAppSelector((state) => state.adminReducer.project);
  const activeBatchJob = useAppSelector((state) => state.batchJobReducer.activeBatchJob);

  const arr = location.pathname.split("/");
  const pathname = arr[arr.length - 1];
  const activeTab = pathname === "settings" || pathname === "log" ? pathname : null;

  const baseUrl = `/project/${project._id}/batchjob/${BatchJobTemplateEnum.BIM360SHEETEXTRACTOR.toLowerCase()}/${
    activeBatchJob?._id
  }`;

  const history = useHistory();

  const goToUrl = (tab: string) => {
    const path = `${baseUrl}/${tab}`;
    history.push(path);
  };

  return (
    <>
      <div style={{ position: "sticky", top: 0, zIndex: 1000 }}>
        <BatchJobSettingsBanner
          nrOfSettingsComplete={activeBatchJob.valid?.nrOfSettingsComplete}
          totalNumberOfSettings={activeBatchJob.valid?.totalNumberOfSettings}
          nextScheduledBatchJob={activeBatchJob.valid?.nextScheduledBatchJob}
        />
      </div>

      <Tabs value={activeTab} onChange={(tab) => tab != null && goToUrl(tab)}>
        <Tabs.List>
          <Tabs.Tab value="log">Logg</Tabs.Tab>
          <Tabs.Tab value="settings">Innstillinger</Tabs.Tab>
        </Tabs.List>
      </Tabs>
      <Switch>
        <Route path={`${baseUrl}/settings`}>
          <Bim360SheetExtractorSettingsPage />
        </Route>
        <Route path={`${baseUrl}/log`}>
          <BatchJobLogPage />
        </Route>
      </Switch>
    </>
  );
};

export default Bim360SheetExtractor;
